import React, { PureComponent } from 'react';
import classnames from 'classnames';
import TrackVisibility from 'react-on-screen';

import QuizMap from '../Map';
import Answers from './Answers';

class QuizItem extends PureComponent {
  state = {
    selectedAnswer: false,
    finished: false,
    isCorrect: null
  }

  handleAnswer(answer) {
    if (this.state.isFinished) {
      return false;
    }

    const correct = answer === this.props.correctAnswer;

    this.setState({ finished: true, selectedAnswer: answer, correct });
    this.props.onAnswer(correct);
  }

  render() {
    const { __id, lng, lat, zoom, answers, correctAnswer, index, description } = this.props;
    const { finished, correct } = this.state;
    const itemClasses = classnames('quizitem', { finished, correct });

    return (
      <div className={itemClasses}>
        <div className="quizitem__title">
          <div className="quizitem__title-index">{index}</div>
          <div className="quizitem__title-text">{description}</div>
        </div>
        <div className="quizitem__map">
          <TrackVisibility once offset={200}>
            <QuizMap
              finished={finished}
              zoom={zoom}
              center={[lng, lat]}
              __id={__id}
            />
          </TrackVisibility>
        </div>
        <Answers
          onAnswer={(answer) => this.handleAnswer(answer)}
          answers={answers}
          correctAnswer={correctAnswer}
          index={index}
          {...this.state}
        />
      </div>
    );
  }
}

export default QuizItem;
